/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiRiskRule,
    InternalApiRiskRuleFromJSON,
    InternalApiRiskRuleToJSON,
    InternalApiRiskRuleUpdate,
    InternalApiRiskRuleUpdateFromJSON,
    InternalApiRiskRuleUpdateToJSON,
    InternalApiRiskRuleVersionUpdate,
    InternalApiRiskRuleVersionUpdateFromJSON,
    InternalApiRiskRuleVersionUpdateToJSON,
    InternalApiScenarioComputedParameter,
    InternalApiScenarioComputedParameterFromJSON,
    InternalApiScenarioComputedParameterToJSON,
} from '../models';

export interface AddNewVersionRequest {
    handle: string;
    internalApiRiskRuleVersionUpdate: InternalApiRiskRuleVersionUpdate;
}

export interface DuplicateVersionRequest {
    handle: string;
    id: number;
}

export interface GetRiskRuleRequest {
    handle: string;
}

export interface GetRiskRuleParametersRequest {
    handle: string;
}

export interface UpdateRiskRuleRequest {
    handle: string;
    internalApiRiskRuleUpdate: InternalApiRiskRuleUpdate;
}

export interface UpdateVersionRequest {
    handle: string;
    id: number;
    internalApiRiskRuleVersionUpdate: InternalApiRiskRuleVersionUpdate;
}

/**
 * 
 */
export class InternalRiskRuleApi extends runtime.BaseAPI {

    /**
     * Add a new version for this risk rule
     */
    async addNewVersionRaw(requestParameters: AddNewVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiRiskRule>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling addNewVersion.');
        }

        if (requestParameters.internalApiRiskRuleVersionUpdate === null || requestParameters.internalApiRiskRuleVersionUpdate === undefined) {
            throw new runtime.RequiredError('internalApiRiskRuleVersionUpdate','Required parameter requestParameters.internalApiRiskRuleVersionUpdate was null or undefined when calling addNewVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk-rule/{handle}/version`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRiskRuleVersionUpdateToJSON(requestParameters.internalApiRiskRuleVersionUpdate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiRiskRuleFromJSON(jsonValue));
    }

    /**
     * Add a new version for this risk rule
     */
    async addNewVersion(requestParameters: AddNewVersionRequest, initOverrides?: RequestInit): Promise<InternalApiRiskRule> {
        const response = await this.addNewVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Duplicate this risk rule version
     */
    async duplicateVersionRaw(requestParameters: DuplicateVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiRiskRule>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling duplicateVersion.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling duplicateVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk-rule/{handle}/version/{id}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiRiskRuleFromJSON(jsonValue));
    }

    /**
     * Duplicate this risk rule version
     */
    async duplicateVersion(requestParameters: DuplicateVersionRequest, initOverrides?: RequestInit): Promise<InternalApiRiskRule> {
        const response = await this.duplicateVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch a risk rule and its versions
     */
    async getRiskRuleRaw(requestParameters: GetRiskRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiRiskRule>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling getRiskRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk-rule/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiRiskRuleFromJSON(jsonValue));
    }

    /**
     * Fetch a risk rule and its versions
     */
    async getRiskRule(requestParameters: GetRiskRuleRequest, initOverrides?: RequestInit): Promise<InternalApiRiskRule> {
        const response = await this.getRiskRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch available parameters for a risk rule
     */
    async getRiskRuleParametersRaw(requestParameters: GetRiskRuleParametersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScenarioComputedParameter>>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling getRiskRuleParameters.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk-rule/{handle}/parameters`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScenarioComputedParameterFromJSON));
    }

    /**
     * Fetch available parameters for a risk rule
     */
    async getRiskRuleParameters(requestParameters: GetRiskRuleParametersRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScenarioComputedParameter>> {
        const response = await this.getRiskRuleParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a risk rule
     */
    async updateRiskRuleRaw(requestParameters: UpdateRiskRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiRiskRule>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling updateRiskRule.');
        }

        if (requestParameters.internalApiRiskRuleUpdate === null || requestParameters.internalApiRiskRuleUpdate === undefined) {
            throw new runtime.RequiredError('internalApiRiskRuleUpdate','Required parameter requestParameters.internalApiRiskRuleUpdate was null or undefined when calling updateRiskRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk-rule/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRiskRuleUpdateToJSON(requestParameters.internalApiRiskRuleUpdate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiRiskRuleFromJSON(jsonValue));
    }

    /**
     * Update a risk rule
     */
    async updateRiskRule(requestParameters: UpdateRiskRuleRequest, initOverrides?: RequestInit): Promise<InternalApiRiskRule> {
        const response = await this.updateRiskRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a risk rule version
     */
    async updateVersionRaw(requestParameters: UpdateVersionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiRiskRule>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling updateVersion.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateVersion.');
        }

        if (requestParameters.internalApiRiskRuleVersionUpdate === null || requestParameters.internalApiRiskRuleVersionUpdate === undefined) {
            throw new runtime.RequiredError('internalApiRiskRuleVersionUpdate','Required parameter requestParameters.internalApiRiskRuleVersionUpdate was null or undefined when calling updateVersion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/risk-rule/{handle}/version/{id}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRiskRuleVersionUpdateToJSON(requestParameters.internalApiRiskRuleVersionUpdate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiRiskRuleFromJSON(jsonValue));
    }

    /**
     * Update a risk rule version
     */
    async updateVersion(requestParameters: UpdateVersionRequest, initOverrides?: RequestInit): Promise<InternalApiRiskRule> {
        const response = await this.updateVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
